<template>
  <!-- menu-provider 提供 $xxMenu 的注入 -- 相当于一个 mini state -->
  <xx-menu-provider class="page-content-outer">
    <div id="layout-iframe-second-menu-outer" style="padding-inline-end: 10px">
      <xx-menu-sidebar />
    </div>
    <div class="page-content-slot">
      <div id="layout-iframe-nav" style="padding-block: 10px">
        <xx-menu-header />
      </div>
      <xx-tab-view />
    </div>
  </xx-menu-provider>
</template>

<script>
import XxTabView from "./TabView";
import { XxMenuProvider, XxMenuHeader, XxMenuSidebar } from "./Menu";
import { detectDeviceType } from "../utils/tools";

export default {
  components: {
    XxTabView,
    XxMenuHeader,
    XxMenuSidebar,
    XxMenuProvider,
  },
  data() {
    return {
      isMobile: detectDeviceType() === "Mobile",
    };
  },
};
</script>

<style lang="scss" scoped>
body {
  box-sizing: border-box;
}

:root,
* {
  box-sizing: border-box;
}

.page-content-outer {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #f5f5f5;
  .page-content-slot {
    flex: 1;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    &.border-bottom {
      border-bottom: 40px solid #3a404d; // 留出移动端底部安全区
    }
  }
}
</style>
